export default "__VITE_ASSET__Dh8LeI_Y__"